import { render } from "./FormOrder.vue?vue&type=template&id=72d70c0a"
import script from "./FormOrder.vue?vue&type=script&lang=js"
export * from "./FormOrder.vue?vue&type=script&lang=js"

import "./FormOrder.vue?vue&type=style&index=0&id=72d70c0a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__